import React, { FC } from 'react';
import Comment from './Comment';
import { Comment as CommentType } from '../../../../../../models/Comment';
import styles from './styles.module.css';
import {
  CommentsState,
  useCommentsState
} from '../../../../../../../providers/Comments';
import { ShowMore } from './ShowMore';
import { Button } from 'antd';

const CommentStream: FC = () => {
  const {
    comments,
    commentsLoading,
    canViewPrivateComments,
    canViewCommitComment,
    page
  } = useCommentsState() as CommentsState;

  if (commentsLoading) {
    return (
      <div className={styles.loaderContainer}>
        <Button type="link" loading className={styles.loadingButton}>
          Loading comments...
        </Button>
      </div>
    );
  }

  const getSortedComments = () => {
    return (comments || [])
      .slice(0)
      .sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      )
      .slice(0, page * 100);
  };

  return (
    <div className="commentsList" onScroll={event => event.stopPropagation()}>
      {getSortedComments()
        .filter(
          comment =>
            (canViewPrivateComments || !comment.isPrivate) &&
            (!comment.commitUrl || canViewCommitComment)
        )
        .map(
          ({
            id,
            userId,
            commitUrl,
            user,
            text,
            commentHtml,
            createdAt,
            isPrivate,
            readByUsers,
            reactions
          }: CommentType) => (
            <Comment
              key={id}
              id={id}
              userId={userId}
              commitUrl={commitUrl}
              text={text}
              commentHtml={commentHtml}
              createdAt={createdAt}
              isPrivate={isPrivate}
              commenter={user}
              readByUsers={readByUsers}
              reactions={reactions}
            />
          )
        )}
      <ShowMore />
    </div>
  );
};

export default CommentStream;
